import {InputWithInsetLabel} from '../../../DanitComponents/Inputs/InputWithInsetLabel'
import { XMarkIcon } from '@heroicons/react/20/solid'
import './auto-generated-family-card.css'

const AutoGeneratedFamilyCard = ({family, monthNumber, addAnExtra, changeExtraDescription, changeExtraAmount, removeExtra}) => {

    return (
        <div className="auto-generated-family-card">
            <div className="auto-generated-family-card__family-name">{family.familyName}</div>
            {family.lessons.map((lesson, index) => (
                <div key={index} className="auto-generated-family-card__each-lesson">
                    <div className="auto-generated-family-card__each-lesson__name">{lesson.studentName}</div>
                    <div className="auto-generated-family-card__each-lesson__date">{monthNumber}/{lesson.date}</div>
                    <div className="auto-generated-family-card__each-lesson__length">{lesson.lessonLength} min</div>
                </div>
            ))}
            {family.extras.length > 0 && <div className="auto-generated-family-card__extras-title">EXTRAS</div>}
            {family.extras.map((extra, index) => (
                <div key={index} className="auto-generated-family-card__each-extra">
                    <div className="auto-generated__extra-description">
                        <InputWithInsetLabel label="Extra" placeholder="Describe extra" value={extra.description} changeFunction={(e) => changeExtraDescription(family.email, index, e.target.value)} />
                    </div>
                    <div className="auto-generated__extra-amount">
                        <InputWithInsetLabel label="Price" placeholder="$" value={extra.amount} changeFunction={(e) => changeExtraAmount(family.email, index, e.target.value)} />
                    </div>
                    <XMarkIcon color='gray' className="auto-generated__extra-x-mark" onClick={() => removeExtra(family.email, index)} />
                </div>
            ))}
            <div className="auto-generated-family-card__add-extra" onClick={() => addAnExtra(family.email)}>+ Add an extra</div>
        </div>
    )
}
export default AutoGeneratedFamilyCard;